(function () {
  var OPEN_KEY = 'cartDrawerTrioPickerOpen';
  var SEEN_KEY = 'cartDrawerTrioPickerSeen';
  var CELEBRATED_KEY = 'cartDrawerTrioCelebrated';
  var LAST_COUNT_KEY = 'cartDrawerTrioLastCount';
  var isAdding = false;

  function formatMoneyCents(cents, format) {
    if (typeof cents !== 'number' || isNaN(cents)) return '';
    var value = format || '${{amount}}';
    var match = value.match(/\{\{\s*(\w+)\s*\}\}/);
    var token = match ? match[1] : 'amount';
    var precision = token.indexOf('no_decimals') > -1 ? 0 : 2;
    var negative = cents < 0;
    var abs = Math.abs(cents);
    var dollars = precision === 0 ? String(Math.round(abs / 100)) : String(Math.floor(abs / 100));
    var out = dollars.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    if (precision > 0) out += '.' + String(abs % 100).padStart(2, '0');
    return value.replace(/\{\{\s*\w+\s*\}\}/, (negative ? '-' : '') + out);
  }

  function getCart() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  function renderPickerRows(list, products) {
    list.innerHTML = '';
    products.forEach(function (product) {
      var row = document.createElement('div');
      row.className = 'cart-drawer__trio-row';

      if (product.image) {
        var img = document.createElement('img');
        img.className = 'cart-drawer__trio-row-thumb';
        img.src = product.image;
        img.alt = '';
        img.loading = 'lazy';
        img.width = 40;
        img.height = 40;
        row.appendChild(img);
      }

      var text = document.createElement('div');
      text.className = 'cart-drawer__trio-row-text';

      var name = document.createElement('span');
      name.className = 'cart-drawer__trio-row-name';
      name.textContent = product.shortName || product.fullTitle;
      text.appendChild(name);

      if (product.gender) {
        var gender = document.createElement('span');
        gender.className = 'cart-drawer__trio-row-gender';
        gender.textContent = product.gender;
        text.appendChild(gender);
      }

      row.appendChild(text);

      var price = document.createElement('span');
      price.className = 'cart-drawer__trio-row-price';
      price.textContent = formatMoneyCents(product.price, window.cartDrawerMoneyFormat);
      row.appendChild(price);

      var addButton = document.createElement('button');
      addButton.type = 'button';
      addButton.className = 'cart-drawer__trio-row-add';
      addButton.textContent = 'ADD';
      addButton.setAttribute('data-trio-chip-add', '');
      addButton.dataset.variantId = product.id;
      row.appendChild(addButton);

      list.appendChild(row);
    });
  }

  function initPicker(root) {
    var list = root.querySelector('[data-trio-picker-list]');
    var dataScript = root.querySelector('[data-trio-eligible-data]');
    if (!list || !dataScript || list.dataset.rendered) return;
    var products = [];
    try {
      products = JSON.parse(dataScript.textContent || '[]');
    } catch (error) {
      products = [];
    }
    renderPickerRows(list, products);
    list.dataset.rendered = '1';
  }

  function openPicker(root) {
    initPicker(root);
    var picker = root.querySelector('[data-trio-picker]');
    if (picker) picker.hidden = false;
    sessionStorage.setItem(OPEN_KEY, '1');
    sessionStorage.setItem(SEEN_KEY, '1');
    root.classList.remove('cart-drawer__trio-slots--hint');
  }

  function closePicker(root) {
    var picker = root.querySelector('[data-trio-picker]');
    if (picker) picker.hidden = true;
    sessionStorage.removeItem(OPEN_KEY);
    sessionStorage.setItem(SEEN_KEY, '1');
    root.classList.remove('cart-drawer__trio-slots--hint');
  }

  function addToCart(button) {
    if (isAdding) return;
    var variantId = parseInt(button.dataset.variantId, 10);
    if (!variantId) return;

    var cart = getCart();
    isAdding = true;
    button.disabled = true;
    button.textContent = '…';

    var body = { items: [{ id: variantId, quantity: 1 }] };
    if (cart) {
      body.sections = cart.getSectionsToRender().map(function (section) {
        return section.id;
      });
      body.sections_url = window.location.pathname;
    }

    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (response) {
        if (response.status) return;
        if (cart) {
          cart.renderContents(response);
          cart.classList.remove('is-empty');
        }
      })
      .catch(function (error) {
        console.error(error);
      })
      .finally(function () {
        isAdding = false;
      });
  }

  document.addEventListener('click', function (evt) {
    var slotButton = evt.target.closest('[data-trio-slot-open]');
    if (slotButton) {
      var slotRoot = slotButton.closest('[data-trio-slots]');
      if (slotRoot) openPicker(slotRoot);
      return;
    }

    var closeButton = evt.target.closest('[data-trio-picker-close]');
    if (closeButton) {
      var closeRoot = closeButton.closest('[data-trio-slots]');
      if (closeRoot) closePicker(closeRoot);
      return;
    }

    var addButton = evt.target.closest('[data-trio-chip-add]');
    if (addButton) {
      addToCart(addButton);
      return;
    }
  });

  var initialRoot = document.querySelector('[data-trio-slots]');
  if (initialRoot && !sessionStorage.getItem(SEEN_KEY)) {
    initialRoot.classList.add('cart-drawer__trio-slots--hint');
  }

  // Belt-and-suspenders: the server-rendered fragment returned by both
  // /cart/add.js and /cart/change.js already contains the correct fill
  // (verified directly against the live theme), so this SHOULD be redundant.
  // But it's cheap, and it makes the bar correct regardless of any client-side
  // swap timing/selector quirk in Dawn's own renderContents/updateQuantity,
  // by reading the fill fraction straight from a fresh, independent /cart.js
  // fetch rather than trusting whatever HTML happened to land in the DOM.
  //
  // The same fetch also drives the trio-completion celebration: unlike the
  // bar, the "complete" markup only exists once item_count >= 3, so the
  // celebration check can't be gated behind "the bar exists" the way the
  // resync above is -- it needs to run on every mutation regardless.
  function resyncTrioProgress() {
    var progress = document.querySelector('.cart-drawer__trio-progress');

    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        if (progress) {
          var bar = progress.querySelector('.cart-drawer__trio-bar');
          if (bar) {
            var pct = 0;
            if (cart.item_count === 1) pct = 33;
            else if (cart.item_count === 2) pct = 66;
            else if (cart.item_count >= 3) pct = 100;
            bar.style.width = pct + '%';
          }
        }
        checkTrioCelebration(cart.item_count);
      })
      .catch(function () {});
  }

  // Only celebrate on the transition INTO the unlocked state (previous count
  // < 3, new count >= 3) within this session, and never on a page load that
  // already starts at 3+ items -- the first check of a session only seeds
  // the "last known count" baseline instead of comparing against it.
  function checkTrioCelebration(itemCount) {
    var lastRaw = sessionStorage.getItem(LAST_COUNT_KEY);
    sessionStorage.setItem(LAST_COUNT_KEY, String(itemCount));
    if (lastRaw === null) return;

    var last = parseInt(lastRaw, 10);
    if (last < 3 && itemCount >= 3 && !sessionStorage.getItem(CELEBRATED_KEY)) {
      sessionStorage.setItem(CELEBRATED_KEY, '1');
      triggerCelebration();
    }
  }

  function animateSavingsCountUp(el, finalCents, duration) {
    var start = null;
    function tick(ts) {
      if (start === null) start = ts;
      var t = Math.min(1, (ts - start) / duration);
      el.textContent = formatMoneyCents(Math.round(finalCents * t), window.cartDrawerMoneyFormat);
      if (t < 1) {
        requestAnimationFrame(tick);
      } else {
        el.textContent = formatMoneyCents(finalCents, window.cartDrawerMoneyFormat);
      }
    }
    requestAnimationFrame(tick);
  }

  function triggerCelebration() {
    var progress = document.querySelector('.cart-drawer__trio-progress--complete');
    if (!progress) return;
    progress.classList.add('cart-drawer__trio-progress--celebrate');

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var amountEl = progress.querySelector('[data-trio-savings-amount]');
    if (!amountEl) return;
    var finalCents = parseInt(amountEl.dataset.finalCents, 10);
    if (!isNaN(finalCents)) animateSavingsCountUp(amountEl, finalCents, 500);
  }

  // Seed the session baseline immediately from the server-rendered initial
  // page (no fetch needed) so a fresh load that already has 3+ items never
  // reads as a "transition" once the observer starts watching for changes.
  var initialProgress = document.querySelector('[data-trio-progress]');
  checkTrioCelebration(initialProgress ? parseInt(initialProgress.dataset.itemCount, 10) || 0 : 0);

  // The cart drawer replaces #CartDrawer's innerHTML wholesale on every cart
  // mutation, so any DOM node reference (and any element-bound listener) from
  // before that point is gone. Delegating from `document` above sidesteps
  // that entirely. This observer handles re-opening the picker across a
  // re-render if the shopper had it open when the mutation happened, and
  // re-syncs the progress bar as a safety net (see resyncTrioProgress above).
  var cartRoot = document.querySelector('cart-drawer');
  if (cartRoot && 'MutationObserver' in window) {
    new MutationObserver(function () {
      resyncTrioProgress();

      var root = document.querySelector('[data-trio-slots]');
      if (!root) {
        sessionStorage.removeItem(OPEN_KEY);
        return;
      }
      if (sessionStorage.getItem(OPEN_KEY) === '1') {
        openPicker(root);
      } else if (!sessionStorage.getItem(SEEN_KEY)) {
        root.classList.add('cart-drawer__trio-slots--hint');
      }
    }).observe(cartRoot, { childList: true, subtree: true });
  }
})();
